export function normalizeBaseUrl(url) {
  if (!url) return "";
  let normalized = url;
  while (normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }
  return normalized;
}

export function joinUrl(base, path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizeBaseUrl(base)}${normalizedPath}`;
}
